import React from "react";
import { Typography } from "@mui/material";
import type { SubheaderProps } from "@components/Subheader/Subheader.types";

const Subheader: React.FC<SubheaderProps> = ({ testId, title, subtitle, children }) => {
  return (
    <div data-testid={testId} className="px-24 pt-4 pb-6 flex flex-col bg-[#F7F8FA] no-print">
      <Typography
        variant="caption"
        data-testid={`${testId}-subtitle`}
        sx={{ color: "text.secondary" }}
      >
        {subtitle}
      </Typography>
      <Typography
        variant="h4"
        data-testid={`${testId}-title`}
        sx={{ fontWeight: 500, fontSize: "32px", textTransform: "capitalize" }}
        className="break-all"
      >
        {title}
      </Typography>
      {children}
    </div>
  );
};

export default Subheader;
